import {getWordBreakClassName} from 'lib/stringHelper';
import PropTypes from 'prop-types';

function TaskMixingDescription({labwareName, wellGroup}) {
  return (
    <>
      &nbsp;
      <span className={`green ${getWordBreakClassName(labwareName, 19)}`}>{labwareName}</span>
      &nbsp;
      <span>Well(s)</span>
      &nbsp;
      <span className="green">{`[${wellGroup}]`}</span>
    </>
  );
}

TaskMixingDescription.propTypes = {
  labwareName: PropTypes.string,
  wellGroup: PropTypes.string,
};

TaskMixingDescription.defaultProps = {
  wellGroup: '',
  labwareName: '',
};

export default TaskMixingDescription;
